module.exports = __webpack_public_path__ + "img/ka.076c6174.png";